import {Component, OnInit, Renderer2} from '@angular/core';
import * as $ from "jquery";
import { LangService } from '../services/lang.service';
import { TranslateService } from '@ngx-translate/core';

declare let Swiper: any;

@Component({
  selector: 'app-langing-buy-now-gyb',
  templateUrl: './langing-buy-now-gyb.component.html',
  styleUrls: ['./langing-buy-now-gyb.component.css']
})
export class LangingBuyNowGybComponent implements OnInit {
  isLangModalOpen = false;

  langOptions = [
    { code: 'en', name: 'English',    flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch',    flag: '🇩🇪' },
    { code: 'ja', name: '日本語',      flag: '🇯🇵' },
    { code: 'es', name: 'Español',    flag: '🇪🇸' },
    { code: 'fr', name: 'Français',   flag: '🇫🇷' },
  ];

  ngOnInit() {

  }

  constructor(
    public lang: LangService,
    private translate: TranslateService
  ) {}

  ngAfterViewInit() {
    this.translate.stream('banner.title').subscribe(() => {
      setTimeout(() => {
        this.initializeScripts();
      }, 0);
    });
  }

  initializeScripts() {
    $(document).ready(function () {

      // ADD 	BACKGROUND TO PARENT ELEMENT IMAGE

      // @ts-ignore
      function wpc_add_img_bg(img_sel: string, parent_sel: string) {
        if (!img_sel) {
          return false;
        }

        let $parent, _this;

        $(img_sel).each(function () {
          _this = $(this);
          $parent = _this.closest(parent_sel);
          $parent = $parent.length ? $parent : _this.parent();

          const imgSrc = (this as HTMLImageElement).src; //
          $parent.css('background-image', `url(${imgSrc})`);
          _this.hide();
        });
      }

      wpc_add_img_bg('.s-img-switch', '.s-back-switch');

      //SWIPER
      const sliderThumbs = new Swiper('.swiper__thumbs .swiper-container', {
        slidesPerView: 1,
        centeredSlides: true,
        simulateTouch: false,
        loop: true,
        effect: "fade",
        breakpoints: {
          991: {
            slidesPerView: 1,
            loop: false,
          },
        },
        autoplay: {
          delay: 5000,
        },
        speed: 900,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      const sliderInfo = new Swiper('.swiper__info .swiper-container', {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          991: {
            loop: false,
          },
        },
        speed: 900,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        controller: {
          control: sliderThumbs
        }
      });

      // SCROLL TO
      $('#scroll-down, #scroll-down-mobile').on('click', function (event) {
        event.preventDefault();
        const id = $(this).attr('href') as string;
        // @ts-ignore
        const $id = $(id);
        let pos;
        // @ts-ignore
        if ($(window).width() > 991) {
          // @ts-ignore
          pos = $id.offset().top - 100;
        } else {
          // @ts-ignore
          pos = $id.offset().top - 92;
        }
        $('body, html').animate({scrollTop: pos}, 1500);
      });

      //PLAN SWITCHER
      $('.switcher-item').on('click', function (event) {
        $('.switcher-item').removeClass('active');
        $(this).addClass('active');
        const switcherDataAttrClass = `.${$(this).data('plan')}`;
        $('.plan__list__section').removeClass('active');
        $(switcherDataAttrClass).addClass('active');
        checkDetection();
      })

      // PLAN CHECKED
      function checkDetection() {
        const activePlanItemChecked = $('.plan__list__section.active input:checked');

        const checkedRadioButtonPrice = activePlanItemChecked.attr('data-price');
        const checkedRadioButtonSale = activePlanItemChecked.attr('data-sale');
        const checkedRadioButtonAttr = activePlanItemChecked.attr('data-attr');

        // @ts-ignore
        $('.plan__info--pay .price').text(checkedRadioButtonPrice);
        // @ts-ignore
        $('.plan__info--pay .sale').text(checkedRadioButtonSale);
        // @ts-ignore
        $('.buy').attr('data-fsc-item-path-value', checkedRadioButtonAttr);
      }


      $('.plan__list__item--check input').on('change', function () {
        checkDetection();
      });


    })
  }
  openLangModal(): void {
    this.isLangModalOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closeLangModal(): void {
    this.isLangModalOpen = false;
    document.body.style.overflow = '';
  }

  selectLang(code: string): void {
    this.lang.setLang(code);
    this.closeLangModal();
  }
}
